import illustrationUrl from "./assets/illustration.svg";

import { colors, greys } from "@clockwise/web-commons/src/styles/color.styles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";
import { fontFamilySans, size } from "@clockwise/web-commons/src/styles/type.styles";

const containerFixed = {
  inset: 0,
  display: "flex",
  zIndex: 10,
  overflow: "auto",
  position: "fixed",
  backgroundColor: "rgba(238, 240, 241, 1)",
} as const;

const innerContainer = {
  width: "100%",
  height: "100%",
  margin: "auto",
  overflow: "hidden",
  maxWidth: "1200px",
  minWidth: "1200px",
  maxHeight: "800px",
  minHeight: "700px",
  borderRadius: "10px",
} as const;

const popover = {
  width: "100%",
  height: "100%",
  display: "flex",
  overflow: "hidden",
  position: "relative",
  background: "#fff",
  flexDirection: "column",
  transformOrigin: "right bottom",

  margin: "auto",
  maxWidth: "1200px",
  minWidth: "1200px",
  maxHeight: "800px",
  minHeight: "700px",
  borderRadius: "10px",
} as const;

const container = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "42px 20px",
  transition: "opacity 1s",
} as const;

const h1 = {
  width: 630,
  textAlign: "center",
  fontSize: 21,
  marginBottom: 0,
  lineHeight: "35px",
} as const;

const illustration = {
  padding: "20px 0 40px 0",
} as const;

const mainContainer = {
  padding: 70,
  flex: 1,
  display: "flex",
  flexDirection: "column",
  height: "100%",
  width: "100%",
  alignItems: "center",
} as const;

const logo = {
  fill: colors.blueDusk.standard,
  style: {
    width: 182,
  },
} as const;

const logoContainer = {
  display: "flex",
  alignItems: "center",
} as const;

const addIcon = {
  padding: "0px 5px 0px 9px",
  fontSize: 38,
  fill: colors.blueDusk.standard,
} as const;

const content = {
  width: "100%",
  maxWidth: 1200,
  height: 500,
  padding: "60px 80px 16px",
  backgroundImage: `url(${illustrationUrl})`,
  backgroundPosition: "right 70px top 50px",
  backgroundRepeat: "no-repeat",
  backgroundSize: "450px auto",
} as const;

export const header = {
  textAlign: "left",
  fontSize: 24,
  lineHeight: 1.5,
  marginBottom: 0,
  paddingBottom: 30,
} as const;

const lineItemContainer = {
  marginBottom: 35,
  maxWidth: 420,
} as const;

const lineItemHeader = {
  fontFamily: fontFamilySans,
  fontSize: 16,
  lineHeight: 1.5,
  color: greys.slate,
  margin: "10px 0",
  "& > span": {
    paddingRight: 5,
  },
} as const;

const lineItemBody = {
  fontFamily: fontFamilySans,
  fontSize: 16,
  lineHeight: 1.5,
  color: greys.slate,
  marginBottom: 30,
} as const;
const footer = {
  position: "sticky",
  bottom: 40,
  alignSelf: "center",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
} as const;

const linksContainer = {
  fontFamily: fontFamilySans,
  fontSize: 12,
  lineHeight: "18px",
  color: greys.slate,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 260,
  textAlign: "center",
} as const;

const footerLinks = {
  color: greys.slate,
} as const;

const primaryButton = {
  backgroundColor: colors.green.darker,
  border: "none",
  borderRadius: 24,
  padding: "0 24px",
  paddingRight: 8,
  paddingTop: 8,
  paddingBottom: 6,
  boxShadow: "none",
  color: greys.white,
  textTransform: "none",
  "&:hover": {
    backgroundColor: colors.green.lighter,
  },
} as const;

export const styles = {
  mainContainer,
  container,
  h1,
  illustration,
  logo,
  logoContainer,
  addIcon,
  content,
  header,
  lineItemContainer,
  lineItemHeader,
  lineItemBody,
  footer,
  popover,
  innerContainer,
  containerFixed,
  linksContainer,
  footerLinks,
  primaryButton,
} as const;

export const signupBtn = {
  base: {
    height: 45,
    lineHeight: `45px`,
    width: "100%",
    maxWidth: 320,
  },
  label: {
    fontWeight: 500,
    fontFamily: fontFamilySans,
    fontSize: size.std,
    paddingLeft: spacing.std,
    paddingRight: spacing.lg,
    color: greys.white,
    textTransform: "none",
  },
} as const;

export const logoStyles = {
  fill: colors.blueDusk.standard,
  style: {
    width: 182,
  },
} as const;

export const loadingBar = {
  backgroundColor: "transparent",
  position: "absolute",
  bottom: 0,
  width: "100%",
} as const;
